module.exports = __webpack_public_path__ + "img/hotel-vila-gale-sintra-resort-hotel-conference-revival-spa.696e18e0.jpg";